import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, Output, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gs-area-material',
  templateUrl: './gs-area-material.component.html',
  styleUrls: ['./gs-area-material.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GsAreaMaterialComponent),
      multi: true
    }
  ]
})
export class GsAreaMaterialComponent implements ControlValueAccessor, AfterViewInit, OnChanges {
  @ViewChild('textArea') 
  textArea: ElementRef;
  // Inputs
  @Input() label: string;
  @Input() labelSmall: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() formControl: UntypedFormControl;
  @Input() readOnly: boolean = false;
  @Input() cssClass: string;
  @Input() hideErrorMessage: boolean = false;
  @Input() rows: number;

  // Outputs
  @Output() blur: EventEmitter<string> = new EventEmitter<string>();

  // Private variables
  private inputValue: string;

  // Public variables
  public fnOnChange: any = () => { };
  public fnOnTouch: any = () => { };

  constructor(private el: ElementRef, private renderer: Renderer2) {

  }

  ngAfterViewInit(): void {

  }

  ngOnChanges() {

  }

  private triggerChange($event) {
    this.fnOnChange($event);
    const event = new CustomEvent('change', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }

  // Public methods

  public set value(val: string) {
    if (val !== undefined) {
      this.inputValue = val;
    }
  }

  public get value() {
    return this.inputValue;
  }

  public writeValue(val: string): void {
    this.value = val;
  }

  public writePlaceholder(val: string): void {
    this.placeholder = val;
  }

  public registerOnChange(fn: any): void {
    this.fnOnChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.fnOnTouch = fn;
  }

  public onChange() {
    this.triggerChange(this.inputValue);
  }

  public labelClick(){
    this.textArea.nativeElement.focus();
  }
}
